import * as React from 'react';
import { Col, Row } from 'reactstrap';
import CountUp from 'react-countup';
import { toastr } from 'react-redux-toastr';
import ChartLoader from 'src/share/components/ChartLoader/ChartLoader';
import { IProvidersStatsResult } from 'src/share/types/provider';
import { StackedBarsChart } from 'src/share/components/Chart/StackedBarsChart';
import { ReportsService, ReportTypes, ProvidersReportsOptions } from 'src/share/services/reports';
import { IntervalTypes, loadingProvider } from 'src/share/utils/intervals';

interface IProviderStatsContainerProps {
  loading: boolean;
  stats: IProvidersStatsResult;
  provider: string;
  interval: IntervalTypes;

}

const providerStackChartProps = {
  dataKey: 'date',
  dateKey: 'date',
  key1: 'valid',
  key2: 'invalid',
  lineKey: 'faces'
};

const ProviderStatsContainer = ({ loading, stats, provider, interval }: IProviderStatsContainerProps) => {
  const getReport = async () => {
    try {
      await ReportsService.get(ReportTypes.PROVIDERS, ProvidersReportsOptions[provider.toUpperCase()], { interval });
    } catch (error) {
      toastr.error('Error', 'There was a problem getting the report');
    }
  }
  return (
    <Row className="white-background margin-big-card">
      <Col className="col-md-12 col-12 margin-top-20">
        <div className="provider-info">
          <h3>
            {provider}
            &nbsp;
            {stats.images.length > 0 && !loading &&
              <span onClick={() => getReport()} className="subOption">
                (download)
            </span>}
          </h3>
          <h5>Total of images received: <CountUp end={stats.total.valid + stats.total.invalid} /></h5>
        </div>
        <p>Faces detected: <CountUp end={stats.total.faces} /></p>
        <p>Valid images: <CountUp end={stats.total.valid} /></p>
        <p>Invalid images: <CountUp end={stats.total.invalid} /></p>
      </Col>
      <Col className="col-md-12 col-12 margin-top-20">
        <ChartLoader
          chart={StackedBarsChart}
          data={loading ? loadingProvider(interval) : stats.images}
          loader={StackedBarsChart}
          loading={loading}
          {...providerStackChartProps} />
      </Col>
    </Row>
  );
}

export default ProviderStatsContainer;



// WEBPACK FOOTER //
// ./src/modules/UserSettings/ProvidersStats/components/ProviderStatsContainer.tsx